module.exports = __webpack_public_path__ + "static/board-25-6e6c4d667c30bfd2af83761fd9a7e24a.jpg";